import React from "react"
import { FaCode, FaSketch, FaAndroid } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "C++",
    text: `A 5 year experience of programming in c++. Well versed with the Standard Template Library.`,
  },
  {
    id: 2,
    icon: <FaCode className="service-icon" />,
    title: "Java",
    text: `A 4 year experience of programming in java. Worked a lot on object oriented programming using java and the collections framework.`,
  },
  {
    id: 3,
    icon: <FaCode className="service-icon" />,
    title: "JavaScript",
    text: `An amateur programmer with vanilla javascript. A beginner in react framework.`,
  },
]
